import firebase from "firebase";
import store, { block, showBlock, hideBlock } from "../canvas/store";
// import { blockState } from "../scheduler/index";
//const csp = require("js-csp");
//import * as csp from "js-csp";

const csp = window.csp;

export const Events = {
  COUNTDOWN_FINISHED: "countdown/finished",
  VIDEO_FINISHED: "video/finished",
  NEW_DONATION: "streamlabs/donation"
};

export const EventMaker = {
  countdownFinished: id => ({ event: Events.COUNTDOWN_FINISHED, countdown: id }),
  videoFinished: id => ({ event: Events.VIDEO_FINISHED, element: id }),
  newDonation: id => ({ event: Events.NEW_DONATION, donation: id })
};

let chans = {};
let onlyNew = false;
let userId;

const createChan = id => {
  chans[id] = csp.chan();
  csp.go(function*() {
    while (block(id).stayDuration !== undefined) {
      const event = yield csp.take(chans[id]);
      console.log(event);
      if (block(id).stayDuration !== undefined) {
        showBlock(id);
        if (block(id).stayDuration > 0) {
          yield csp.timeout(block(id).stayDuration);
          hideBlock(id);
        }
        yield csp.timeout(2000);
      }
    }
  });
};

const ensureChans = (interestedIds, event) => {
  interestedIds.forEach(id => {
    if (!chans[id]) {
      createChan(id);
    }
    csp.putAsync(chans[id], event);
  });
};

const interestedBlocks = eventName => {
  return store.blockIds.filter(id => block(id).showWhen === eventName);
};

export const setupListeners = uid => {
  userId = uid;

  //firebase hack to use firebase as an event queue
  //all previous events are called in child added so need to use onlyNew
  firebase
    .database()
    .ref("/events/" + uid)
    .on("child_added", snap => {
      onlyNew && ensureChans(interestedBlocks(snap.val().event), snap.val());
    });
  firebase
    .database()
    .ref("/events/" + uid)
    .limitToFirst(1)
    .once("value", snap => {
      onlyNew = true;
    });
};

export const dispatchEvent = event => {
  firebase
    .database()
    .ref("/events/" + userId)
    .push()
    .set(event);
};



// WEBPACK FOOTER //
// ./src/trigger/index.js